import styled from 'styled-components'
import {Button} from "@mui/material";

export const StyledButton = styled(Button)`
    display: flex !important;
    padding: 0.75rem 0 !important;
    justify-content: center !important;
    align-items: center;
    width: 100% !important;
    margin: 0.25rem 0 !important;
    border-radius: 1rem !important;
    cursor: pointer;

    font-family: var(--fontMain) !important;
    font-size: 1rem !important;
    font-style: normal !important;
    font-weight: 500 !important;
    text-transform: unset !important;
    line-height: 1.5rem !important;
    letter-spacing: 0.46px !important;

    &.Mui-disabled {
        opacity: 0.55 !important;
    }

    @media(max-width:768px){
        font-size: 0.8rem !important;
    }
`
